query CardHolderAvailableTags($id: UUID!) {
  cardHolderAvailableTags(entityId: $id) {
    nodes {
      id
      name
      badgeName
      badgeColor
    }
  }
}
